import type { NavLink } from '@sifly/shared-types'

/**
 * True when a nav entry actually links somewhere.
 *
 * A dropdown parent is often authored with no link of its own — `set_menu_links`
 * writes `href: ''` for a group label by design, and the website importer keeps
 * a parent whose own page did not import as a label over its children. Rendered
 * as `<a href="">` that entry links to whatever page the visitor is on: a click
 * reloads the page instead of doing nothing, and a keyboard user can never open
 * the hover-only dropdown. The header and the mobile drawer render such an
 * entry as a toggle / heading instead.
 */
export function hasNavHref(entry: Pick<NavLink, 'href'>): boolean {
  return typeof entry.href === 'string' && entry.href.trim() !== ''
}
